export const testFactory = (exerciseId = null) => {
  return {
    id: null,
    exercise: exerciseId,
    name: '',
    slug: '',
    code: '',
    order: 0,
    is_hidden: false,
    created: null,
    modified: null
  }
}

export const solutionFactory = (exerciseId = null) => {
  return {
    id: null,
    exercise: exerciseId,
    name: '',
    slug: '',
    code: '',
    order: 0,
    created: null,
    modified: null
  }
}